import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-faq',
  imports: [TranslateModule, RouterLink, NzIconModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  backLink: string[] = ['..'];
  answers: { answer: string; question: string; subtext?: string }[] = [];
  protected starterString: string = 'faq';

  constructor(
    private dataService: DataService,
    private translate: TranslateService
  ) {
    this.dataService.companyId$.subscribe((companyId) => {
      if (companyId) {
        const isFasdac = companyId === '45C41017';
        this.starterString = isFasdac ? 'faqFasdac' : 'faq';
        this.answers = this.translate.instant(this.starterString + '.text');
      }
    });
  }
}
